import qs from "qs";
import request from "@/utils/request";
import requestApi from "@/utils/requestApi";
import NListGenerato from "@nxin/nxin-ui-pc/NListGenerato/NListGenerato.vue";

export default {
  components: {
    nListGenerato: NListGenerato,
  },

  data() {
    return {
      env: process.env,
      form: {
        orderId: "",
        orgIdList: [],
        shopIdList: [],
        invoiceStatus: "",
      },
      theadData: [
        {
          prop: "orderId",
          label: "订单号",
          width: 200,
        },
        {
          prop: "fundShopName",
          label: "卖家",
          width: 200,
        },
        // {
        //   prop: "settlementLimit",
        //   label: "可用授信额度",
        //   width: 120,
        // },
        // {
        //   prop: "settlementCn",
        //   label: "结算账期",
        //   width: 120,
        // },
        // {
        //   prop: "settlementDayCn",
        //   label: "最后付款日",
        //   width: 120,
        // },
        {
          prop: "orderStatusCn",
          label: "订单状态",
          width: 120,
        },
        {
          prop: "refundStatusCn",
          label: "退款状态",
          width: 120,
        },
        {
          prop: "fmoney",
          label: "订单金额",
          width: 160,
        },
        {
          prop: "goodsName",
          label: "订单商品",
          width: 200,
        },
        {
          prop: "unitCn",
          label: "计量单位",
          width: 120,
        },
        {
          prop: "goodsQuantity",
          label: "数量",
          width: 120,
        },
        {
          prop: "contract",
          label: "电子合同",
          type: "custom",
          width: 150,
        },
        {
          prop: "createTime",
          label: "申请时间",
        },
        {
          prop: "invoiceStatusCn",
          label: "开票状态",
          type: "custom",
        },
        {
          prop: "fn",
          label: "操作",
          type: "custom",
        },
      ],
      tbodyData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchData: [
        {
          tag: "input",
          prop: "orderId",
          value: "",
          label: "订单",
          placeholder: "请输入订单号",
        },
        {
          tag: "select",
          prop: "orgIdList",
          value: [],
          label: "单位",
          remote: true,
          loading: true,
          options: [],
          multiple: true,
          placeholder: "支持搜索/多选/默认全部",
        },
        {
          tag: "select",
          prop: "shopIdList",
          value: process.env.NODE_ENV == "production" ? ["6999867391440005567", "6999867391440011842"] : [],
          label: "卖家",
          options: [],
          multiple: true,
          placeholder: "支持搜索/多选/默认全部",
        },
        {
          tag: "select",
          prop: "invoiceStatus",
          value: "",
          label: "开票状态",
          options: [
            {
              value: "WSQ",
              label: "未申请",
            },
            {
              value: "CS",
              label: "未开票",
            },
            {
              value: "PROCESS",
              label: "开票中",
            },
            {
              value: "SUCCESS",
              label: "已开票",
            },
          ],
          placeholder: "请选择",
        },
      ],
      buttonFunctionData: [
        // {
        //   tag: "button",
        //   icon: "el-icon-download",
        //   prop: "export",
        //   type: "primary",
        //   label: "导出",
        // },
      ],
      supplierList: [],
      orgIdSelected: [],
      // 发票列表
      refId: "",
      invoiceList: [],
    };
  },

  created() {
    const body = document.querySelector("body");
    body.classList.add("seller-style");
    requestApi.post(`sctrading/shop/selShopList`, {}).then((res) => {
      if (res.code == "0") {
        this.supplierList = res.data;
        this.searchData[2].options = res.data.map((item) => ({
          value: item.shopId,
          label: item.name,
        }));
      }
    });
  },

  mounted() {
    this.loadData();
  },

  methods: {
    //发票上传
    uploadInvoiceSuccess(res) {
      console.log("上传图片成功之后", res);
      const { code, msg, data } = res;
      if (code != 0) {
        this.$message.error(msg);

        return;
      }

      this.uploadInvoice(data);
    },
    uploadInvoiceBefore(file, orderId) {
      const { size, type } = file;
      console.log("fileSize: ", size);
      console.log("fileType: ", type);
      this.refId = orderId;
      const isVerify = /(jpg|bmp|jpeg|png)$/.test(type);
      const isVerify2 = /(pdf)/.test(type);
      let isLt3M = size / 1024 / 1024 < 50;
      let sizeErr = "上传大小不能超过 50MB";
      if (!isVerify && !isVerify2) {
        this.$message.error("上传必须是JPG/BMP/JPEG/PNG/PDF/格式");
      } else if (!isLt3M) {
        this.$message.error(sizeErr);
      }
      return (isVerify || isVerify2) && isLt3M;
    },
    uploadInvoiceExceed() {
      this.$message.warning("最多上传2张图片");
    },
    async uploadInvoice(uploadData) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { code, msg } = await requestApi.post(`sctrading/order/orderinvoice/upload`, {
        fileList: [
          {
            busType: "SELLER",
            fileType: "ORDER_INVOICE",
            refId: this.refId,
            url: uploadData.url,
            name: uploadData.name,
          },
        ],
      });
      loading.close();

      if (code == "0") {
        this.loadData();
      } else {
        this.$message.error(msg);
      }
    },
    async loadData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { code, msg, data } = await requestApi.post(`sctrading/order/orderinvoice/manage/selList`, {
        ...this.form,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      });
      loading.close();

      if (code == "0") {
        this.total = Number(data.total || 0);
        this.tbodyData = data.list;
      } else {
        this.$message.error(msg);
      }
    },
    sizeChange(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.loadData();
    },

    currentChange(current) {
      if (!current || Number.isNaN(Number(current))) {
        return;
      }
      this.pageNum = current;
      this.loadData();
    },

    resetForm() {
      this.$refs.form.resetFields();
    },
    searchSubmit(form) {
      console.log("form", form);
      this.form = form;
      this.loadData();
    },

    async orgIdListRemoteMethod(name) {
      if (!name) {
        return;
      }

      this.searchData[1].loading = true;
      const { code, msg, data } = await request.post(`nxin.usercenter.org.find/3.0`, qs.stringify({ name, page_index: 1, page_size: 50 }));
      this.searchData[1].loading = false;
      if (code == "0") {
        const dataArr = JSON.parse(JSON.stringify(this.orgIdSelected));
        (data.data || []).forEach((item) => {
          if (!dataArr.some((item2) => item2.value == item.orderId)) {
            dataArr.push({
              value: item.id,
              label: item.name,
            });
          }
        });
        this.searchData[1].options = dataArr;
      } else {
        this.$message.error(msg);
      }
      this.searchData[1].loading = false;
    },
    orgIdListSelectChange(value) {
      if (value && value.length) {
        const { options } = this.searchData[1];
        const orgIdSelected = [];
        (options || []).forEach((item) => {
          if (value.includes(item.value)) {
            orgIdSelected.push(item);
          }
        });
        this.orgIdSelected = orgIdSelected;
      } else {
        this.orgIdSelected = [];
      }
    },

    async handleExport() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { msg, code, data } = await requestApi.post(`sctrading/purchase/purchasepaycheckrecord/export`, this.form);
      loading.close();

      if (code == "0") {
        this.$open(data.url, { target: 1 });
      } else {
        this.$message.error(msg);
      }
    },

    async viewContract(contract) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { code, msg, data } = await requestApi.post(`sctrading/contract/info/getContractUrl`, {
        contractId: contract.contractId,
      });
      loading.close();

      if (code == "0") {
        this.$open(data, { target: 1 });
      } else {
        this.$message.error(msg);
      }
    },
    // 打开文件
    viewFile(url) {
      this.$open(url, { target: 1 });
    },
    // 获取文件名称
    getFileName(url) {
      return url.split("/").pop();
    },
    // 合并行
    tableSpanMethod({ row, column, rowIndex }) {
      // console.log("row", row);
      // console.log("column", column);
      // console.log("rowIndex", rowIndex);
      // console.log("columnIndex", columnIndex);

      const { tbodyData } = this;
      const orderIdMerge = ["orderId"];
      const orderIdFundShopNameMerge = ["fundShopName", "orderStatusCn", "fmoney", "contract", "invoiceStatusCn", "createTime", "fn"];
      if (orderIdMerge.includes(column.property)) {
        let rowspan = 1;
        let colspan = 1;
        if (rowIndex) {
          let indexUp = rowIndex - 1;
          if (tbodyData[indexUp] && row.orderId == tbodyData[indexUp].orderId) {
            rowspan = 0;
            colspan = 0;
          } else {
            let index = rowIndex + 1;
            rowspan = 1;
            colspan = 1;
            while (tbodyData[index] && (!tbodyData[index].orderId || row.orderId == tbodyData[index].orderId)) {
              index++;
              rowspan++;
            }
          }
        } else {
          let index = rowIndex + 1;
          while (tbodyData[index] && row.orderId == tbodyData[index].orderId) {
            index++;
            rowspan++;
          }
        }

        return {
          rowspan,
          colspan,
        };
      } else if (orderIdFundShopNameMerge.includes(column.property)) {
        let rowspan = 1;
        let colspan = 1;
        if (rowIndex) {
          let indexUp = rowIndex - 1;
          if (tbodyData[indexUp] && row.orderId == tbodyData[indexUp].orderId && row.fundShopName == tbodyData[indexUp].fundShopName) {
            rowspan = 0;
            colspan = 0;
          } else {
            let index = rowIndex + 1;
            rowspan = 1;
            colspan = 1;
            while (tbodyData[index] && row.orderId == tbodyData[index].orderId && row.fundShopName == tbodyData[index].fundShopName) {
              index++;
              rowspan++;
            }
          }
        } else {
          let index = rowIndex + 1;
          while (tbodyData[index] && row.orderId == tbodyData[index].orderId && row.fundShopName == tbodyData[index].fundShopName) {
            index++;
            rowspan++;
          }
        }

        return {
          rowspan,
          colspan,
        };
      }
    },
  },
};
